/**
 * Section Types — backward-compatible export derived from WIDGET_REGISTRY.
 *
 * Consumers import SECTION_TYPES from here. The data now comes from
 * widget-definitions/ via the toSectionTypes() helper, ensuring a single
 * source of truth in WIDGET_REGISTRY.
 */

import { WIDGET_REGISTRY, toSectionTypes } from '../widget-definitions';

export const SECTION_TYPES = toSectionTypes(WIDGET_REGISTRY);

// Named exports for backward compatibility
export const heroSectionType = WIDGET_REGISTRY['hero'].schema;
export const productGridSectionType = WIDGET_REGISTRY['product-grid'].schema;
export const categoryGridSectionType = WIDGET_REGISTRY['category-grid'].schema;
export const announcementBarSectionType = WIDGET_REGISTRY['announcement-bar'].schema;
export const textBlockSectionType = WIDGET_REGISTRY['text-block'].schema;
export const productCarouselSectionType = WIDGET_REGISTRY['product-carousel'].schema;
export const featuredProductsSectionType = WIDGET_REGISTRY['featured-products'].schema;
export const productsWeekSectionType = WIDGET_REGISTRY['products-week'].schema;
export const staticCategoriesSectionType = WIDGET_REGISTRY['static-categories'].schema;
export const containerFrameSectionType = WIDGET_REGISTRY['container-frame'].schema;
